

import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Filmographie from '../views/Filmographie.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/filmographie',
    name: 'Filmographie',
    component: Filmographie
  },
  {
    path: '/technique',
    name: 'Technique',
    // route level code-splitting
    // this generates a separate chunk (Technique.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Technique" */ '../views/Technique.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
